import { passCodes } from '../passCodes';
import track18 from '../../../../assets/audio/tracks/track18.mp3';

const hints = [
    {
        text: 'Podívejte se nahoru ke korouhvi, zámeček se nachází kousek za školkou Sluníčko.',
    },
    {
        text: 'Je to číslo mezi 5 a 7.',
    },
    {
        text: 'Kódem je: 6',
        solution: true,
    },
];
export const step18castle = {
    id: 17,
    title: '7. stanoviště',
    taskText: `
        <p>
            Jo, a ještě jsem si vzpomněl, kolik prosím tě bylo kytek nahoře na tý střeše toho mini zámečku? Prý to taky budeme potřebovat, říkal ten voják, promiň, jsem předtím zapomněl.
        </p>
    `,
    catImage: 2,
    audio: track18,
    snowAudio: track18,
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[11],
    additionalInfo: 'Odpovědí je číslo.',
    hints: hints,
    snowHints: hints,
};
